import type { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useFeatureFlags } from '@hooks/useFeatureFlags';
import { isSubmissionPath } from '@utils/app-paths';

import type { StepProps } from '../../types';

import { Step2Ddb } from './Step2Ddb';
import { Step2OpenSearch } from './Step2OpenSearch';

export const Step2: FC<StepProps> = ({ control, formValues, setValue }) => {
  const [searchParams] = useSearchParams();
  const getFeatureFlagState = useFeatureFlags();
  const isOpenSearchEnabled = getFeatureFlagState('OpenSearch') && searchParams.get('source') !== 'ddb';

  if (isOpenSearchEnabled && isSubmissionPath()) {
    return <Step2OpenSearch control={control} formValues={formValues} setValue={setValue} />;
  }

  return <Step2Ddb control={control} formValues={formValues} setValue={setValue} />;
};
